module.exports = __webpack_public_path__ + "柴舸洋-39663e9b.png";